"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.walletsPath = exports.walletDetailPath = exports.subNavOptions = exports.settingsNav = exports.routeTemplate = exports.mainNavOptions = exports.AssignRoutes = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _config = _interopRequireDefault(require("../config"));
var _path = _interopRequireDefault(require("../helpers/path"));
var AdvancedTemplate = _interopRequireWildcard(require("./advancedTemplate"));
var RetailTemplate = _interopRequireWildcard(require("./retailTemplate"));
var LondonTemplate = _interopRequireWildcard(require("./londonTemplate"));
var MilanAltTemplate = _interopRequireWildcard(require("./milanAltTemplate"));
var EotcTemplate = _interopRequireWildcard(require("./EotcTemplate"));
var basicTradingTemplate = _interopRequireWildcard(require("./basicTradingTemplate"));
var v3standardTemplate = _interopRequireWildcard(require("./v3standardTemplate"));
var _settingsRoutes = require("./settingsRoutes");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mainNavOptions = exports.mainNavOptions = {
  mainNavItems: [],
  settingsPath: ''
};
var subNavOptions = exports.subNavOptions = {
  subNavItems: []
};
var settingsNav = exports.settingsNav = {
  items: []
};
var walletsPath = exports.walletsPath = {
  path: ''
};
var walletDetailPath = exports.walletDetailPath = {
  path: ''
};
var routeTemplate = exports.routeTemplate = {
  routes: function routes() {
    return /*#__PURE__*/_react["default"].createElement("div", null, " Loading ");
  }
};
var AssignRoutes = exports.AssignRoutes = function AssignRoutes() {
  switch (_config["default"].global.template) {
    case 'MILAN':
    case 'RETAIL':
      AssignRouteValues(RetailTemplate);
      break;
    case 'MILAN-ALT':
      AssignRouteValues(MilanAltTemplate);
      break;
    case 'NEWYORK':
    case 'ADVANCED':
      AssignRouteValues(AdvancedTemplate);
      break;
    case 'CAPETOWN':
    case 'BASICTRADING':
      AssignRouteValues(basicTradingTemplate);
      break;
    case 'LONDON':
      AssignRouteValues(LondonTemplate);
      break;
    case 'GALAXY':
    case 'EOTC':
      AssignRouteValues(EotcTemplate);
      break;
    case 'STANDARD':
      AssignRouteValues(v3standardTemplate);
      break;
    default:
      AssignRouteValues(RetailTemplate);
      break;
  }
};
var AssignRouteValues = function AssignRouteValues(source) {
  mainNavOptions.mainNavItems = source.mainNavOptions.mainNavItems;
  mainNavOptions.settingsPath = source.mainNavOptions.settingsPath;
  subNavOptions.subNavItems = source.subNavItems;
  settingsNav.items = _settingsRoutes.settingsNavItems;
  walletsPath.path = source.walletsPath;
  walletDetailPath.path = source.walletDetailPath;
  routeTemplate.routes = SetupRoutes(source.routesArray);
};
var SetupRoutes = function SetupRoutes(routesArray) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, routesArray.concat(_settingsRoutes.settingsRoutesArray).filter(function (i) {
    return i.show === undefined || i.show;
  }).map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      exact: item.exact,
      path: (0, _path["default"])(item.path),
      key: item.path,
      render: item.render
    });
  }));
};